import { render, staticRenderFns } from "./WearehouseManagement.vue?vue&type=template&id=090a4ccf&scoped=true&"
import script from "./WearehouseManagement.vue?vue&type=script&lang=js&"
export * from "./WearehouseManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090a4ccf",
  null
  
)

export default component.exports